import { ONE_SECOND_IN_MS } from "./timeIntervals";
import Decimal from "decimal.js";

/** Seconds with at most 3 dp, so every accepted value maps to a whole number of ms. */
export const SECONDS_INPUT_REGEX = /^\d+(?:\.\d{1,3})?$/;

/** ms → seconds for display; sub-second values must survive the round trip (4500 → "4.5"). */
export const msToSecondsString = (ms: number): string => new Decimal(ms).div(ONE_SECOND_IN_MS).toString();

/** A seconds text input → whole ms, or null when it isn't a non-negative number of seconds with ≤3 dp. */
export const secondsInputToMs = (raw: string): number | null => {
  const trimmed = raw.trim();
  if (!SECONDS_INPUT_REGEX.test(trimmed)) return null;
  return new Decimal(trimmed).mul(ONE_SECOND_IN_MS).toNumber();
};
